const SearchInvoiceForm = ({ toggleFilters }) => {
  return (
    <>
      {toggleFilters && (
        <div className="bg-gray rounded mb-3 p-3">
          <div className="row">
            <div className="col-lg-3 form-group">
              <label for="searchcolumns" className="form-label fw-bolder">
                Search By
              </label>
              <select
                name="searchcolumns"
                id="searchcolumns"
                className="form-control"
              >
                <option value="" selected>
                  -- Select --
                </option>
                <option value="invoice_number">Invoice Number</option>
                <option value="amount">Amount</option>
                <option value="invoice_status">Invoice Status</option>
                <option value="updated_at">Update Time</option>
                <option value="updated_by">Update By</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="search" className="form-label fw-bolder">
                Search
              </label>
              <input
                type="text"
                name="search"
                id="search"
                className="form-control"
              />
            </div>
            <div className="col-lg-3 form-group">
              <label for="orderby" className="form-label fw-bolder">
                Order By
              </label>
              <select name="orderby" id="orderby" className="form-control">
                <option value="" selected>
                  -- Select --
                </option>
                <option value="invoice_number">Invoice Number</option>
                <option value="ID">ID</option>
                <option value="amount">Amount</option>
                <option value="paid_date">Date</option>
                <option value="payment_type">Payment Type</option>
                <option value="invoice_status">Invoice Status</option>
                <option value="updated_at">Update Time</option>
                <option value="created_by">Created By</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="order" className="form-label fw-bolder">
                Order
              </label>
              <select name="order" id="order" className="form-control">
                <option value="ascending">Ascending</option>
                <option value="descending">Descending</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="user_id" className="form-label fw-bolder">
                User
              </label>
              <select name="user_id" id="user_id" className="form-control">
                <option value="" selected="selected">
                  --Select--
                </option>
                <option value="10">Amir</option>
                <option value="9">Bashir</option>
                <option value="2">Imtiaz</option>
                <option value="3">Jamil</option>
                <option value="5">Miqbal</option>
                <option value="4">Qaisar</option>
                <option value="7">Sadam</option>
                <option value="1">Tahir</option>
                <option value="8">Test_tahir</option>
                <option value="6">Waqar</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="payment_type" className="form-label fw-bolder">
                Payment Type
              </label>
              <select
                name="payment_type"
                id="payment_type"
                className="form-control"
              >
                <option value="" selected="selected">
                  --Select--
                </option>
                <option value="installment">Installment</option>
                <option value="down_payment">Down Payment</option>
                <option value="possesion">Possesion</option>
                <option value="registery">Registery</option>
                <option value="yearly">Yearly</option>
                <option value="front">Front</option>
                <option value="return">Return</option>
                <option value="others">Others</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="paid_start_date" className="form-label fw-bolder">
                Start Date
              </label>
              <input
                type="date"
                className="form-control"
                name="paid_start_date"
                id="paid_start_date"
                value=""
              />
            </div>
            <div className="col-lg-3 form-group">
              <label for="paid_end_date" className="form-label fw-bolder">
                End Date
              </label>
              <input
                type="date"
                className="form-control"
                name="paid_end_date"
                id="paid_end_date"
                value=""
              />
            </div>
            <div className="col-lg-3 form-group">
              <label for="account_status" className="form-label fw-bolder">
                Account Status
              </label>
              <select
                name="account_status"
                id="account_status"
                className="form-control"
              >
                <option value="all">All</option>
                <option value="open">Open</option>
                <option value="cancel">Cancel</option>
                <option value="close">Close</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label
                for="payment_method"
                className="d-block form-label fw-bolder"
              >
                Payment Source
              </label>
              <input
                type="checkbox"
                name="payment_method[]"
                id="cash1"
                value="cash"
              />
              &nbsp;
              <label for="bf_registery" style={{ fontWeight: 400 }}>
                Cash
              </label>
              &nbsp;
              <input
                type="checkbox"
                name="payment_method[]"
                id="bank2"
                value="bank"
              />
              &nbsp;
              <label for="bf_file" style={{ fontWeight: 400 }}>
                Bank
              </label>
              &nbsp;
              <input
                type="checkbox"
                name="payment_method[]"
                id="others3"
                value="others"
              />
              &nbsp;
              <label for="bf_file" style={{ fontWeight: 400 }}>
                Others
              </label>
            </div>
            <div className="col-lg-3 form-group">
              <label
                for="range_invoice_number"
                className="form-label fw-bolder w-100"
              >
                Invoice Number Range
              </label>
              <input
                type="text"
                className="form-control"
                name="range_invoice_number"
                id="range_invoice_number"
                value="0"
                style={{ width: "20%", float: "left" }}
              />
              <input
                type="range"
                className="form-range bg-light m-2"
                id="customRange1"
                style={{ width: "40%", float: "left" }}
              />
              <input
                type="text"
                className="form-control"
                name="end_house_number"
                id="end_house_number"
                value="1000"
                style={{ width: "30%", float: "right" }}
              />
            </div>
            <div className="col-lg-3 form-group">
              <label for="account_stage" className="form-label fw-bolder">
                Account Stage
              </label>
              <select
                name="account_stage"
                id="account_stage"
                className="form-control"
              >
                <option value="" selected>
                  -- Select --
                </option>
                <option value="booking">Booking</option>
                <option value="possesion">Possesion</option>
              </select>
            </div>
            <div className="clearboth"></div>
          </div>
          <div className="row">
            <div className="col-lg-12 pb-3">
              <input
                type="submit"
                className="btn site_btn text-white"
                value="Search"
              />
              <button className="btn site_btn text-white mx-3">Reset</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SearchInvoiceForm;
